// extracted by mini-css-extract-plugin
export default {"invoiceModal":"invoiceModal_invoiceModal__Yl5LC"};